module dg.objects {


    //angular.module('dg.objects')
    //    .component('multilineTextDisplayer', {
    //        bindings: {
    //            value: '<'
    //        },
    //        //template: '<textarea class="form-control noresize" readonly ng-bind="$ctrl.value"></textarea>',
    //        template: '<p ng-bind="$ctrl.value"></p>',
    //    });
}
